module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Italic.woff2?f8fbca842004f92b132b45838657c4b9";